export default __webpack_public_path__ + "static/media/sms.6eaf1efb.svg";